import { render, staticRenderFns } from "./ListChapters.vue?vue&type=template&id=4322a6d0&scoped=true&"
import script from "./ListChapters.vue?vue&type=script&lang=js&"
export * from "./ListChapters.vue?vue&type=script&lang=js&"
import style0 from "./ListChapters.vue?vue&type=style&index=0&id=4322a6d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4322a6d0",
  null
  
)

export default component.exports